/**
 * OperationsCenter feature-flag accessor.
 *
 * Kept as a single-export module so tests can spy on the accessor
 * without round-tripping process.env, which is partially inlined by
 * CRA's babel-transform pipeline and resistant to runtime mutation.
 *
 * In production this is effectively a constant — the env var is inlined
 * at build time and the function returns a stable boolean.
 */

export function isOpsCenterEnabled() {
  return process.env.REACT_APP_ENABLE_EVENT_OPERATIONS_CENTER === 'true';
}
